export enum Xpress50IncentiveType {
    None = 0,
    Morning = 1,
    Evening = 2
}
